export default __webpack_public_path__ + "media/images/front/about/instagram-da45870c54f688dae7c69df31872f21e.png";